<!-- Completed Step -->
<a (click)="onStepChange.emit()"
   [ngClass]="{
             'border-theme-primary-700 hover:border-theme-primary-800': current >= model,
             'border-gray-200 hover:border-gray-300': current < model,
             }"
   class="group flex flex-col border-l-4 md:border-t-4 md:border-l-0 md:pt-2 md:pb-0 pl-4">
            <span [ngClass]="{
                  'text-theme-primary-700 group-hover:text-theme-primary-800': current >= model,
                  'text-gray-500 group-hover:text-gray-700': current < model
                  }"
                  class="text-sm font-medium">Schritt {{ index + 1 }}</span>
  @if (label) {
    <span class="text-sm font-medium">{{ label }}</span>
  }

</a>
